<template>
    <div :class="loading ? 'loading-data' : ''">

        <div v-if="!showAllFields">

            <div class="mb-3">
                <QueryDetailsForm v-model="queryDetails"></QueryDetailsForm>
            </div>

            <div v-if="this.isSmartSearch" class="text-end">
                <button
                    type="button"
                    class="btn btn-lg btn-outline-secondary"
                    @click.stop="cancel()"
                    v-if="refpage"
                >
                    Cancel
                </button>

                <b-button variant="primary" size="lg" class="m-2" v-if="!isSaveDisabled" @click="saveSmartQuery">
                    <i class="fas fa-save"></i> {{saveLabel}}
                </b-button>
                <b-button variant="primary" size="lg" class="m-2 fake-disabled" v-else
                    @mouseover="loginReminder('show')"
                    @mouseout="loginReminder('hide')"
                    v-b-tooltip.hover.v-warning="saveTooltip">
                    <i class="fas fa-save"></i> {{saveLabel}}
                </b-button>
            </div>

            <div class="row" v-if="!this.isSmartSearch">
                <div class="col-lg-4 col-md-6 col-sm-12">
                    <field name="FiscalYear"/>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12" v-if=" checkIfVisible('PI')">
                    <field name="PI"/>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12" v-if=" checkIfVisible('Organization')">
                    <field name="Organization"/>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12 search-field-container" v-if=" checkIfVisible('City')">
                    <field name="City"/>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12 search-field-container" v-if=" checkIfVisible('State')">
                    <field name="State"/>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12 search-field-container" v-if=" checkIfVisible('Country')">
                    <field name="Country"/>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12 search-field-container" v-if=" checkIfVisible('CongressionalDistrict')">
                    <field name="CongressionalDistrict"/>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12" v-if=" checkIfVisible('AgencyIC')">
                    <field name="AgencyIC"/>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12" v-if=" checkIfVisible('DepartmentTypes')">
                    <field name="DepartmentTypes"/>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12" v-if=" checkIfVisible('OrganizationTypes')">
                    <field name="OrganizationTypes"/>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12 project-number-group" v-if=" checkIfVisible('ProjectNumber')">
                    <field name="ProjectNumber" class="project-number-multi"/>
                    <div class="row project-number-split">
                        <div class="project-number-or">OR</div>
                        <div class="col-lg-1 col-md-1 col-sm-1 lessPadding char-1">
                            <field name="appl_type_code"/>
                        </div>
                        <div class="col-lg-2 col-md-2 col-sm-2 lessPadding char-3">
                            <field name="activity_code"/>
                        </div>
                        <div class="col-lg-2 col-md-2 col-sm-2 lessPadding char-2">
                            <field name="ic_code"/>
                        </div>
                        <div class="col-lg-3 col-md-3 col-sm-3 lessPadding char-6">
                            <field name="serial_num"/>
                        </div>
                        <div class="col-lg-2 col-md-2 col-sm-2 lessPadding char-2">
                        <field name="support_year"/>
                        </div>
                        <div class="col-lg-2 col-md-2 col-sm-2 lessPadding char-4">
                            <field name="suffix_code"/>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12" v-if=" checkIfVisible('PO')">
                    <field name="PO"/>
                </div>

                <div class="col-lg-4 col-md-6 col-sm-12" v-if=" checkIfVisible('SpendingCategories')">
                    <field name="SpendingCategories"/>
                </div>

                <div class="col-lg-4 col-md-6 col-sm-12" v-if=" checkIfVisible('AwardTypes')">
                    <field name="AwardTypes"/>
                </div>

                <div class="col-lg-4 col-md-6 col-sm-12" v-if=" checkIfVisible('ActivityCodes')">
                    <field name="ActivityCodes"/>
                </div>

                <div class="col-lg-4 col-md-6 col-sm-12" v-if=" checkIfVisible('CooperativeAgreement')">
                    <field name="CooperativeAgreement"/>
                </div>

                <div class="col-lg-4 col-md-6 col-sm-12" v-if=" checkIfVisible('StudySections')">
                    <field name="StudySections"/>
                </div>

                <div class="col-lg-4 col-md-6 col-sm-12" v-if=" checkIfVisible('ProjectStartDate')">
                    <field name="ProjectStartDate"/>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12" v-if=" checkIfVisible('ProjectEndDate')">
                    <field name="ProjectEndDate"/>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12" v-if=" checkIfVisible('AwardNoticeDate')">
                    <field name="AwardNoticeDate"/>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12" v-if=" checkIfVisible('FOA')">
                    <field name="FOA"/>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12" v-if=" checkIfVisible('covid19')">
                    <field name="covid19"/>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12" v-if=" checkIfVisible('ARRASearch')">
                    <field name="ARRASearch"/>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12" v-if=" checkIfVisible('AwardAmountRange')">
                    <field name="AwardAmountRange"/>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12 stackable-fields" v-if=" checkIfVisible('multiplePIOnly') ||  checkIfVisible('newlyAddedProjectsOnly') ||  checkIfVisible('ExcludeSubprojects') || checkIfVisible('outcomesOnly')">
                    <field name="ExcludeSubprojects" v-if=" checkIfVisible('ExcludeSubprojects')"/>
                    <field name="outcomesOnly" v-if=" checkIfVisible('outcomesOnly')"/>
                    <field name="multiplePIOnly" v-if=" checkIfVisible('multiplePIOnly')"/>
                    <field name="newlyAddedProjectsOnly" v-if=" checkIfVisible('newlyAddedProjectsOnly')"/>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12" v-if=" checkIfVisible('fundingMechanisms')">
                    <field name="fundingMechanisms"/>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-12" v-if=" checkIfVisible('SearchText')">
                    <field name="Operator"/>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12" v-if=" checkIfVisible('SearchText')">
                    <field name="SearchText"/>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12" v-if=" checkIfVisible('TextSearchField')">
                    <field name="TextSearchField"/>
                </div>
                <div
                    class="col-md-6 search-buttons"
                    :class="!refpage || showAllFields ? 'col-md-4 offset-md-8' : 'col-md-4'"
                >
                    <button
                        type="button"
                        class="btn btn-lg btn-outline-secondary"
                        @click.stop="cancel()"
                        v-if="refpage"
                    >
                        Cancel
                    </button>


                    <b-button variant="primary" size="lg" class="m-2" v-if="!isSaveDisabled" @click="saveQuery" :disabled="loading" >
                        <i class="fas fa-save"></i> {{saveLabel}}
                    </b-button>
                    <b-button variant="primary" size="lg" class="m-2 fake-disabled" v-else
                        @mouseover="loginReminder('show')"
                        @mouseout="loginReminder('hide')"
                        v-b-tooltip.hover.v-warning="saveTooltip">
                        <i class="fas fa-save"></i> {{saveLabel}}
                    </b-button>

                    <button
                        type="button"
                        class="btn btn-lg btn-search"
                        @click.stop="search()"
                        :disabled="loading"
                    >
                        Search
                        <div class="loader" v-if="loading && !isSaving"></div>
                    </button>
                    <field-error
                        v-if="serviceError"
                        :message="serviceErrorMessage"
                        :errorCode="serviceError"
                    />
                </div>
            </div> <!-- // row -->
        </div>

        <div v-if="showAllFields">
            <div class="col-12 text-end" >
                <button
                    type="button"
                    class="btn btn-lg btn-outline-secondary"
                    @click.stop="cancel()"
                    v-if="refpage"
                >
                    Cancel
                </button>

                <b-button variant="primary" size="lg" class="m-2" v-if="!isSaveDisabled" @click="saveQuery" :disabled="loading" >
                    <i class="fas fa-save"></i> {{saveLabel}}
                </b-button>
                <b-button variant="primary" size="lg" class="m-2 fake-disabled" v-else
                    @mouseover="loginReminder('show')"
                    @mouseout="loginReminder('hide')"
                    v-b-tooltip.hover.v-warning="saveTooltip">
                    <i class="fas fa-save"></i> {{saveLabel}}
                </b-button>

                <button
                    type="button"
                    class="btn btn-lg btn-search"
                    @click.stop="search()"
                    :disabled="loading"
                >
                    Search
                    <div class="loader" v-if="loading && !isSaving"></div>
                </button>
                <field-error
                    v-if="serviceError"
                    :message="serviceErrorMessage"
                    :errorCode="serviceError"
                />
            </div>

            <div class="mb-3">
                <QueryDetailsForm v-model="queryDetails"></QueryDetailsForm>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <h4>Researcher and Organization</h4>
                </div>
            </div>

            <div class="row">
                <div class="col-lg-4 col-md-6 col-sm-12">
                    <field name="FiscalYear"/>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12">
                    <field name="PI"/>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12">
                    <field name="Organization"/>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12 search-field-container">
                    <field name="City"/>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12 search-field-container">
                    <field name="State"/>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12 search-field-container">
                    <field name="Country"/>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12 search-field-container">
                    <field name="CongressionalDistrict"/>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12">
                    <field name="DepartmentTypes"/>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12">
                    <field name="OrganizationTypes"/>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <h4>Text Search</h4>
                </div>
            </div>

            <div class="row">
                <div class="col-lg-2 col-md-2 col-sm-12">
                    <field name="Operator"/>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-12">
                    <field name="SearchText"/>
                </div>

                <div class="col-lg-4 col-md-4 col-sm-12">
                    <field name="TextSearchField"/>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <h4>Project Details</h4>
                </div>
            </div>

            <div class="row">
                <div class="col-lg-4 col-md-6 col-sm-12">
                    <field name="AgencyIC"/>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12">
                    <field name="SpendingCategories"/>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12">
                    <field name="fundingMechanisms"/>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12">
                    <field name="AwardTypes"/>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12 project-number-group">
                    <field name="ProjectNumber" class="project-number-multi"/>
                    <div class="row project-number-split">
                        <div class="project-number-or">OR</div>
                        <div class="col-lg-1 col-md-1 col-sm-1 lessPadding char-1">
                            <field name="appl_type_code"/>
                        </div>
                        <div class="col-lg-2 col-md-2 col-sm-2 lessPadding char-3">
                            <field name="activity_code"/>
                        </div>
                        <div class="col-lg-2 col-md-2 col-sm-2 lessPadding char-2">
                            <field name="ic_code"/>
                        </div>
                        <div class="col-lg-3 col-md-3 col-sm-3 lessPadding char-6">
                            <field name="serial_num"/>
                        </div>
                        <div class="col-lg-2 col-md-2 col-sm-2 lessPadding char-2">
                        <field name="support_year"/>
                        </div>
                        <div class="col-lg-2 col-md-2 col-sm-2 lessPadding char-4">
                            <field name="suffix_code"/>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12">
                    <field name="ActivityCodes"/>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12">
                    <field name="CooperativeAgreement"/>
                </div>
                 <div class="col-lg-4 col-md-6 col-sm-12">
                    <field name="StudySections"/>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12">
                    <field name="PO"/>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12">
                    <field name="ProjectStartDate"/>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12">
                    <field name="ProjectEndDate"/>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12">
                    <field name="AwardNoticeDate"/>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12">
                    <field name="FOA"/>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <h4>Additional Filters</h4>
                </div>
            </div>

            <div class="row">
                <div class="col-lg-4 col-md-6 col-sm-12">
                    <field name="covid19"/>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12">
                    <field name="AwardAmountRange"/>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12 stackable-fields">
                    <field name="ExcludeSubprojects"/>
                    <field name="outcomesOnly"/>
                    <field name="multiplePIOnly"/>
                    <field name="newlyAddedProjectsOnly"/>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12">
                    <field name="ARRASearch"/>
                </div>
            </div>

            <div class="col-12 text-end">
                <button
                    type="button"
                    class="btn btn-lg btn-outline-secondary"
                    @click.stop="cancel()"
                    v-if="refpage"
                >
                    Cancel
                </button>

                <b-button variant="primary" size="lg" class="m-2" v-if="!isSaveDisabled" @click="saveQuery" :disabled="loading" >
                    <i class="fas fa-save"></i> {{saveLabel}}
                </b-button>
                <b-button variant="primary" size="lg" class="m-2 fake-disabled" v-else
                    @mouseover="loginReminder('show')"
                    @mouseout="loginReminder('hide')"
                    v-b-tooltip.hover.v-warning="saveTooltip">
                    <i class="fas fa-save"></i> {{saveLabel}}
                </b-button>

                <button
                    type="button"
                    class="btn btn-lg btn-search"
                    @click.stop="search()"
                    :disabled="loading"
                >
                    Search
                    <div class="loader" v-if="loading && !isSaving"></div>
                </button>
                <field-error
                    v-if="serviceError"
                    :message="serviceErrorMessage"
                    :errorCode="serviceError"
                />
            </div>
        </div>

        <div class="row" v-if="!this.isSmartSearch">
            <div class="col-12 text-center">
                <button  type="button" class="btn btn-sm btn-light ms-5" @click.stop="showAllFields = !showAllFields; serviceError = null" >
                    <span v-show="showAllFields"><i class="fas fa-compress-alt"></i></span> <!-- Workaround for FA, use NPM version of FA instead -->
                    <span v-show="!showAllFields"><i class="fas fa-expand-alt"></i></span>
                    {{ showAllFields ? 'Mini Search' : 'All Search Fields' }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import FieldError from '@/components/searchFields/FieldError.vue'
import Field from '@/components/searchFields/Field.vue';
import QueryDetailsForm from '@/components/QueryDetailsForm.vue';
import { userService } from '@/shared/user.service.js';
import bus from '@/shared/event-bus.js';
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';

import moment from 'moment';



// import MultiSelect from '@/components/searchFields/MultiSelect.vue';
// import InputText from '@/components/searchFields/InputText.vue';

// import FiscalYear from '@/components/searchFields/FiscalYear.vue';
// import AgencyIC from '@/components/searchFields/AgencyIC.vue';

export default {
    name: 'ReviseSearch',
    components: {
        Field,
        FieldError,
        QueryDetailsForm
    },
    computed: {
        ...mapGetters([
            'searchCriteria',
            'searchFieldErrors',
            'editSearchResults',
            'currentQueryDetails',
            'searchType',
            'externalURLs'
        ]),

        saveLabel: function() {
            return this.isSaveDisabled ? "Sign In to Save" : this.currentQueryDetails != null && this.currentQueryDetails.id != 0 ? "Update" : "Save";
        },

        isSmartSearch: function() {
            return this.searchType === 'Smart';
        }
    },
    props: {
        refpage: {
            required: false
        }
    },
    data: function () {
        return {
            showAllFields: true,
            parsedCriteria: null,
            loading: false,
            criteria: null,
            sharedSpec: window.searchFieldSpecs,
            criteriaOnLoad: null,
            isBlankSearch: true,
            serviceError: null,
            serviceErrorMessage: null,
            queryDetails: { //this is .sync with QueryDetailsForm, holds user accessible fields required for saving/updating queries...
                title: "",
                notes: "",
                alerts: [],
                id: 0
            },
            isSaving: false, //flag indicating the save flow...
            isSaveDisabled: true, //if logged in, this will be set to false...
            saveTooltip: 'Use the Sign In button in the top right to enable Saving'
        };
    },
    async created () {
        var criteria = window.parseCriteria(this.$store.state.searchCriteria, {});

        if (this.$store.state.editSearchResults) {
            criteria = window.parseCriteria(this.$store.state.editSearchCriteria, {isEditCriteria: true});
        }

        this.criteria = criteria;
        this.parsedCriteria = window.stringifySearchCriteriaFields(criteria, {isEditCriteria: true});
        this.criteriaOnLoad = copyData(this.$store.state.searchCriteria);

        //if loggedin, enable Save button...
        const currentUser = await userService.getCurrentUser();
        if(currentUser != null) {
            this.isSaveDisabled = false;
        }
        else {
            //emit here to UM to refresh since logged out....
            bus.$emit('update:search');
        }

        //for smart search, wipe the local queryDetails if not working with a current QD (Ex: new Smart search)...
        if(this.isSmartSearch) {
            this.showAllFields = false;
            if (this.currentQueryDetails == null) {
                this.queryDetails = {
                    title: "",
                    notes: "",
                    alerts: [],
                    id: 0
                }
            }
        }

    },
    mounted () {
        document.addEventListener('keydown', this.handleInputEvent);
    },
    destroyed () {
        document.removeEventListener('keydown', this.handleInputEvent);
    },
    methods: {
        ...mapActions([
            'setSearchCriteria',
            'setSearchMeta',
            'setSearchResults',
            'setEditSearchResultsFlag',
            'setSearchFacetData',
            'setSearchFacetCriteria',
            'setSearchType',
            'setCurrentQueryDetailsAction'
        ]),
        handleInputEvent (event) {
            let SmartSearchText = this.$store.state.searchCriteria.smart_search_text,
                $this = this;

            if (event.keyCode === 13) {
                if (SmartSearchText === '' || SmartSearchText === null || SmartSearchText === undefined) {
                    if (event.target && event.target.classList && !event.target.classList.contains('btn-clear') && !event.target.classList.contains('multiselect__remove_all') && !event.target.classList.contains('multiselect__tag__remove') && !event.target.classList.contains('btn-show-all-fields')) {
                        event.preventDefault();

                        //submit search
                        setTimeout(function () {
                            $this.search();
                        }, 501);
                    }
                }
            }
        },
        checkIfVisible (fieldName) {
            var fieldId = this.sharedSpec[fieldName].id;

            if (fieldName === 'SearchText') {
                fieldId = 'advanced_text_search';
            }
            if (!this.refpage || (this.parsedCriteria)) {
                if (this.sharedSpec[fieldName].fields) {

                    for (let field in this.sharedSpec[fieldName].fields) {
                        if (this.parsedCriteria[field]) {
                            this.isBlankSearch = false;
                            return true;
                        }
                    }
                    if (this.sharedSpec[fieldName].alternetFields) {
                        for (let i = 0; i < this.sharedSpec[fieldName].alternetFields.length; i++) {
                            let field = this.sharedSpec[fieldName].alternetFields[i];

                            if (this.parsedCriteria[field]) {
                                this.isBlankSearch = false;
                                return true;
                            }
                        }
                    }
                } else if (fieldName.indexOf('Date') !== -1) {
                    if (this.parsedCriteria[fieldId] && (this.parsedCriteria[fieldId].from_date || this.parsedCriteria[fieldId].to_date)) {
                        this.isBlankSearch = false;
                        return true;
                    }
                } else if (fieldName.indexOf('Range') !== -1) {
                    if (this.parsedCriteria[fieldId] && (this.parsedCriteria[fieldId].min_amount || this.parsedCriteria[fieldId].max_amount)) {
                        this.isBlankSearch = false;
                        return true;
                    }
                } else if (fieldName === 'TextSearchField') {
                    if (this.parsedCriteria.advanced_text_search && this.parsedCriteria.advanced_text_search[window.searchFieldSpecs[fieldName].dependentField]) {
                        return true;
                    }
                } else if (fieldName.indexOf('SearchText') !== -1) {
                    if (this.parsedCriteria[fieldId] && this.parsedCriteria[fieldId].search_text) {
                        this.isBlankSearch = false;
                        return true;
                    }
                } else if (this.parsedCriteria[fieldId] || this.parsedCriteria[fieldId + '__free_text'] ||  this.parsedCriteria[this.sharedSpec[fieldName].idFreeText]) {
                    this.isBlankSearch = false;
                    return true;
                } else if (this.parsedCriteria && this.sharedSpec[fieldName].additionalControl) {
                    for (let i = 0; i < this.sharedSpec[fieldName].additionalControl.options.length; i++) {
                        if (this.parsedCriteria[this.sharedSpec[fieldName].additionalControl.options[i].name] && this.parsedCriteria[fieldId]) {
                            this.isBlankSearch = false;
                            return true;
                        }
                    }
                }
            }

            return false;
        },

        reset () {
            this.$store.state.searchCriteria = copyData(this.$store.state.searchCriteriaDefault);
			gtag('event','Click', {
				'event_category': 'Search Results',
				'event_label': 'Projects Search - Reset',
				'value': 'Projects Search - Reset'
			});	
        },

        cancel () {
            this.$store.state.searchCriteria = copyData(this.criteriaOnLoad);
            this.showAllFields = false;
            //TODO: reaching for $parent is not good, but is widely used in this codebase; consider using emit/$listeners...
            this.$parent.showCriteria = false;

            this.serviceError = null;
			gtag('event','Click', {
				'event_category': 'Search Results',
				'event_label': 'Projects Search Results - Cancel',
				'value': 'Projects Search Results - Cancel'
			});	
        },

        clear () {
            this.setSearchCriteria(null);
			gtag('event','Click', {
				'event_category': this.refpage ? 'Search Results' : 'Home',
				'event_label': 'Projects Search - Clear',
				'value': 'Projects Search - Clear'
			});	
        },

        toggleAllFields () {
            if (this.$parent.toggleFullForm) {
                this.$parent.toggleFullForm();
            } else {
                this.showAllFields = !this.showAllFields;
            }

            // this.showAllFields = !this.showAllFields;
            if (this.showAllFields) {
				gtag('event','Click', {
					'event_category': this.refpage ? 'Search Results' : 'Home',
					'event_label': 'Projects Search - Hide Fields',
					'value': 'Projects Search - Hide Fields'
				});	
            } else {
                gtag('event','Click', {
					'event_category': this.refpage ? 'Search Results' : 'Home',
					'event_label': 'Projects Search - Show All Fields',
					'value': 'Projects Search - Show All Fields'
				});	
            }
        },

        showHideFields () {
            var fieldContainers = this.$el.getElementsByClassName('search-field-container');

            if (!this.showAllFields) {
                for (let i = 0; i < fieldContainers.length; i++) {
                    let container = fieldContainers[i],
                        field = container.getElementsByClassName('search-field')[0];

                    setTimeout(() => {
                        let openHeight = field.offsetHeight;

                        // field.style.position = 'absolute';
                        field.classList.add('transition');

                        container.style.height = '0px';
                        container.style.transition = '0.3s';
                        container.style.overflow = 'hidden';

                        setTimeout(() => {
                            container.style.height = openHeight + 'px';

                            setTimeout(() => {
                                container.style.transition = '';
                                container.style.overflow = '';
                                // field.style.position = '';
                                field.classList.remove('transition');
                                // container.style.height = '';
                            }, 3000);
                        }, 1);
                    }, 1);
                    // });
                }
            } else {
                for (let i = 0; i < fieldContainers.length; i++) {
                    let container = fieldContainers[i],
                        field = container.getElementsByClassName('search-field')[0];

                    this.$nextTick(() => {

                        // let openHeight = field.offsetHeight;
                        // field.style.position = 'absolute';
                        field.classList.add('transition');

                        container.style.transition = '0.3s';
                        container.style.height = '0px';
                        container.style.overflow = 'hidden';
                        // setTimeout(() => {
                        //     container.style.height = openHeight + '0px';
                        setTimeout(() => {
                            // container.style.height = '';
                            container.style.transition = '';
                            container.style.overflow = '';
                            // field.style.position = '';
                            field.classList.remove('transition');
                        }, 3000);
                        // }, 1);
                    });
                }
            }
        },

        formHasErrors () {
            for (let field in this.searchFieldErrors) {
                if (this.searchFieldErrors[field].preventSearch) {
                    return true;
                }
            }

            return false;
        },

        search () {
            var parsedCriteria = window.parseCriteria(this.searchCriteria, {isEditCriteria: false, isSubmitForm: true}),
                criteria = window.stringifySearchCriteriaFields(parsedCriteria, {});

            this.serviceError = null;
            if (!this.formHasErrors()) {
                this.$router.push ({ query: '' }).catch(()=>{});
				gtag('event','Click', {
					'event_category': this.refpage ? 'Search Results' : 'Home',
					'event_label': 'Projects Search - Submit',
					'value': 'Projects Search - Submit'
				});	

                this.loading = true;

                this.setEditSearchResultsFlag(false);
                this.$parent.showHideLinkText = 'More';
                this.setSearchType('Advanced');
                this.setSearchFacetCriteria(null);
                bus.$emit('update:searchResults', true, this.handleEditSearch);
                this.$nextTick(() => {
                    bus.$emit('update:searchCriteria');
                });
            } else {
                console.error('form validation error');
            }

			gtag('event','Click', {
				'event_category': this.refpage ? 'Search Results' : 'Home',
				'event_label': 'Projects Search - Submit',
				'value': 'Projects Search - Submit'
			});	

            // if (this.$parent.$parent) {
            //     this.$parent.$parent.showCriteria = false;
            // }
        },

        async handleEditSearch (data) {
            let $this = this;
            this.$router.push ({ query: '' }).catch(()=>{});
			gtag('event','Click', {
				'event_category': this.refpage ? 'Search Results' : 'Home',
				'event_label': 'Projects Search - Submit',
				'value': 'Projects Search - Submit'
			});	


            if (data && data.meta && data.results) {
                this.$store.state.editSearchCriteria = {};
                this.$parent.showHideLinkText = 'More';
                bus.$emit('update:showCriteria', false);
                bus.$emit('clear:searchResults', {resetFacets: true});
                this.setSearchType('Advanced');
                bus.$emit('update:searchResultsData', data);
                // Save and Update Search Block.....
                //if isSaving, make the save service call, and toast....
                setTimeout(() => {
                    if($this.isSaving)    {
                        $this.processSave();
                    }
                }, 1000);
                // End Save and Update Block...

            }
            else {
                bus.$emit('update:showCriteria', true);
                this.serviceError = this.externalURLs.reporter_project_search_error_message;

                this.$nextTick(() => {
                    switch (this.$route.name) {
                        case 'list':
                            this.$parent.$parent.$parent.loading = false;
                            if (this.$parent.$parent.$parent.projectListTable) {
                                this.$parent.$parent.$parent.projectListTable.isLoading = false;
                            }
                            break;
                        case 'charts':
                            if (this.$parent.$parent.$parent.$refs.Charts) {
                                this.$parent.$parent.$parent.$refs.Charts.loadingGraphData = false;
                            }
                            break;
                    }
                });
            }

            this.loading = false;
        },

        updateSearchResultsFacets (data) {
            if (!data.status) {
                this.setSearchFacetData(data);
                this.setSearchFacetCriteria(data);
            } else {
                this.facetError = true;
                this.setSearchFacetData(null);
                this.setSearchFacetCriteria(null);
            }
        },

        // searchResultsCallback (data) {
        //     this.loading = false;

        //     if (data && data.meta && data.results) {
        //         var url = '/search/';
        //         if (this.$parent.showCriteria) {
        //             this.$parent.showCriteria = false;
        //         }
        //         this.setSearchMeta(data.meta);
        //         this.setSearchResults('a2', data.results);
        //         // this.$parent.$parent.$refs.dataTable.initTableData();
        //         this.$parent.buildCriteria();
        //         url += data.meta.search_id;
        //         url += '/projects/';
        //         if (this.$parent.sortField) {
        //             url += '?sort_field=' + this.$parent.sortField + '&sort_order=' + this.$parent.sortOrder;
        //         }
        //         this.$router.push(url);
        //         //this.getSearchResultsFacets(this.updateSearchResultsFacets);
        //     }

        //     // TODO: add error handling for search results here in future
        // }


        saveQuery() {
            this.isSaving = true;
            this.search(); //this has many async calls and callbacks, which are not proper await, so no code after this line
        },
        saveSmartQuery() {
            this.processSave();
            this.$parent.showCriteria = false;
        },
        loginReminder(showhide)    {
            bus.$emit(`bv::${showhide}::tooltip`, 'user-menu-dd');
        },
        storeUnsavedSearchDetails () {
            this.setCurrentQueryDetailsAction(this.queryDetails);
        },
        async processSave() {
            //if user did not enter a title, auto generate one...
            if (this.currentQueryDetails) {
                this.queryDetails = copyData(this.currentQueryDetails);
            }
            this.queryDetails.search_id = this.$route.params.search_id;
            if(this.queryDetails.title.trim() === "") {
                this.queryDetails.title = "Search " + moment().format('MM/DD/YYYY HH:mm:ss');
            }

            try {
                if(this.currentQueryDetails != null && this.currentQueryDetails.id != null && this.currentQueryDetails.id != 0) { //Performing an update....
                    let saved = await userService.updateSearch(this.queryDetails);
                }
                else { // Performing a save...
                    let saved = await userService.createSearch(this.queryDetails);

                    if(saved!=null) {
                        // successMsg = true;
                        //set the newly saved id...
                        this.queryDetails.id = saved;
                    }
                }

                //update store with the latest (in sync with this.qd and qd.qd)...
                this.setCurrentQueryDetailsAction(this.queryDetails);

                toast.success(`<strong>Search Saved</strong>\nYour Search was Saved successfully.`, {
                    autoClose: 2000, 
                    dangerouslyHTMLString: true,
                    closeButton: true
                });

                bus.$emit('update:search'); //let the menu know to update...
            }
            catch(error) {

                this.$parent.showCriteria = true;

                //NOTE: this will show the err msg from Backend - use with caution, or massage here...
                toast.error(`<strong>An error occured, and your search was not Saved.</strong>\n` + (error.message || 'Error: Search Not Saved'), {
                    autoClose: 2000, 
                    dangerouslyHTMLString: true,
                    closeButton: true
                });
            }
            finally {
                this.isSaving = false;  //reset this flag...
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import 'node_modules/bootstrap/scss/_functions';
@import 'node_modules/bootstrap/scss/_variables';
@import '@/scss/variables.scss';
@import 'node_modules/bootstrap/scss/_mixins';

.loader {
    display: inline-block;
    position: relative;
    vertical-align: middle;
    width: 4em;
    height: 4em;
    top: -2px;
    left: 0;
    margin-left: 0.5em;
    border-width: 2px;
    border-top-color: rgba(255, 255, 255, 0.25);
    border-right-color: rgba(255, 255, 255, 0.25);
    border-bottom-color: rgba(255, 255, 255, 0.25);
    border-left-color: rgba(255, 255, 255, 1);
}

.search-field {
    transition: 0.3s;
}

.loading-data {
    .search-field {
        opacity: 0.5;
    }
}

.lessPadding {
    padding: 0 2px;
}

.hidden {
    opacity: 0;
    // visibility: hidden;
}

.hidden-absolute {
    position: absolute;
    opacity: 0;
    // visibility: hidden;
}

.animate {
    transition: 0.3s;
}

.search-form {
    margin: 15px -15px;
}

.search-field-container {
    position: relative;
}

.search-buttons {
    font-size: 18px;
    margin-top: 1.5em;
    margin-bottom: 1.5em;

    &.advanced-search {
        margin-top: 0;
        margin-bottom: 0;

        &.search-buttons-top {
            @media screen and (min-width: $screen-sm) {
                margin-top: -21.6px;
            }
        }
    }
}

.search-utility-buttons {
    text-align: center;
}

.btn-clear {
    width: calc(45% - 0.75em);
}

.btn-search {
    @include button-variant($green-dark, $green-dark);
    // width: 55%;

    &:disabled {
        opacity: 1;
    }
}

.btn-round {
    @include button-variant($green-light, $green-light);
    color: $green-dark;

    min-width: calc(33% - #{$grid-gutter-width * 0.5});
}


.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}


/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(10px);
  opacity: 0;
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.absolute-fade-fade-enter-active {
  transition: all .3s ease;
  position: absolute;
}
.absolute-fade-fade-leave-active {
  transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.absolute-fade-fade-enter, .absolute-fade-fade-leave-to
/* .absolute-fade-fade-leave-active below version 2.1.8 */ {
  transform: translateY(10px);
  opacity: 0;
}

.btn.fake-disabled {
    opacity: .65;
}

</style>